













import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import debounce from 'lodash/debounce';

@Component
export default class extends Vue {
  @Prop({default: 'Buscar', type: String, required: false})
  public label: string;

  @Prop({type: String, required: true})
  public value: string;

  public valueInternal: string = '';

  @Watch('value')
  public watchValue(newValue: string) {
    this.valueInternal = newValue;
  }

  public get onInput() {
    return debounce(() => {
      this.$emit('input', this.valueInternal);
    }, 500);
  }
}
